import "../css/GlobalBuyerSection.css";

export default function GlobalBuyerSection() {
	return (
		<section className="global-buyer-section">
			<div className="global-container">
				{/* LEFT CONTENT */}
				<div className="global-content">
					<h2>
						Why Global Buyers <span>Choose Us</span>
					</h2>

					<p className="section-intro">
						Trusted by international buyers for consistent quality,
						reliable manufacturing, and custom-crafted rug
						solutions.
					</p>

					<ul className="feature-list">
						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>In-House Design & Development Expertise</h4>
								<p>
									Original rug designs developed, sampled, and
									approved internally for consistency and
									scalability.
								</p>
							</div>
						</li>

						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>Controlled Manufacturing Operations</h4>
								<p>
									Production executed through dedicated
									artisan manufacturing units under direct
									quality supervision in Bhadohi & Panipat.
								</p>
							</div>
						</li>

						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>Worldwide Export Capability</h4>
								<p>
									End-to-end export coordination for USA,
									Europe, Australia & global markets.
								</p>
							</div>
						</li>

						<li>
							<div className="feature-dot"></div>
							<div>
								<h4>Bespoke Rugs & Custom Development</h4>
								<p>
									Tailored sizes, colors, designs & materials
									to meet project and brand requirements.
								</p>
							</div>
						</li>
					</ul>
				</div>

				{/* RIGHT IMAGES */}
				<div className="container">
					<div className="mb-5 global-images">
						<img
							src="/images/global_buyer/new_sec_1.png"
							alt="Rug design detail"
						/>
					</div>

					<div className="global-images">
						<img
							src="/images/global_buyer/new_sec_2.png"
							alt="Rug design detail"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
